import { Visibility } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useDownloadURL } from "react-firebase-hooks/storage";
import { useFirebase } from "contexts/Firebase";
import { IconButton, Typography } from "@mui/material";
import { ref as storageRef } from "firebase/storage";


export function DownloadFile({ file }: { file: { name: string; type: string; path: string } }) {
  const { storage } = useFirebase();
  const [downloadURL, loading, error] = useDownloadURL(storageRef(storage, file.path));

  if (loading) {
    return <Typography variant="body1">{file.name}</Typography>;
  }
  if (error) {
    return (
      <Typography variant="body1">
        Error: {file.name}: {error.message}
      </Typography>
    );
  }
  if (!downloadURL) return <Typography variant="body1">{file.name}</Typography>;

  return (
    <Link style={{ textDecoration: "none", marginLeft: "10px" }} to={downloadURL} target="_blank" download>
      <IconButton>
        <Visibility />
      </IconButton>
    </Link>
  );
}
